import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en";
import tr from "./tr";

const resources = {
  en: { translation: en },
  tr: { translation: tr }
};

// LocalStorage'da kayıtlı dil varsa al, yoksa tarayıcı dilini kullan
const savedLanguage = localStorage.getItem("i18nextLng") || navigator.language.split("-")[0] || "en";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
